import { useContext } from 'react';
import Context from './Context';

const useFBAuth = () => {
  const authContext = useContext<any>(Context);
  return authContext;
}

export default useFBAuth;
